import { HttpErrorResponse } from '@angular/common/http';

export interface TemplateErrorMessage {
  /** Translation key under WORKCLASSIFICATION.TEMPLATES.ERROR (or an override). */
  key: string;
  params?: Record<string, unknown>;
  code: string | null;
}

const PREFIX = 'WORKCLASSIFICATION.TEMPLATES.ERROR.';

const CODE_KEYS: Record<string, string> = {
  TEMPLATE_NAME_EXISTS: 'NAME_EXISTS',
  NAME_REQUIRED: 'NAME_REQUIRED',
  SOURCE_TREE_EMPTY: 'SOURCE_TREE_EMPTY',
  SOURCE_PROJECT_NOT_FOUND: 'PROJECT_NOT_FOUND',
  TEMPLATE_INACTIVE: 'TEMPLATE_INACTIVE',
  TEMPLATE_EMPTY: 'TEMPLATE_EMPTY',
  TEMPLATE_NOT_FOUND: 'TEMPLATE_NOT_FOUND',
  NOT_FOUND: 'NOT_FOUND',
  PROJECT_NOT_FOUND: 'PROJECT_NOT_FOUND',
  PARENT_NOT_IN_TEMPLATE: 'PARENT_INVALID',
  PARENT_CYCLE: 'PARENT_INVALID',
  TARGET_TREE_IN_USE: 'TARGET_TREE_IN_USE',
  SELECTION_REQUIRED: 'SELECTION_REQUIRED',
  BILLED_RENAME_NOT_CONFIRMED: 'BILLED_RENAME_NOT_CONFIRMED',
  PROJECT_NOT_LINKED: 'PROJECT_NOT_LINKED',
  PROJECT_LINKED_TO_OTHER_TEMPLATE: 'PROJECT_LINKED_TO_OTHER_TEMPLATE',
  SAME_PROJECT: 'SAME_PROJECT',
};

/** Reads the backend `{ code }` body of an error response, or null. */
export function errorCode(err: unknown): string | null {
  const body = (err as HttpErrorResponse | undefined)?.error;
  return body && typeof body === 'object' && typeof body.code === 'string' ? body.code : null;
}

/**
 * Maps a template-endpoint error to a translation key. `overrides` replaces the key for a
 * specific code where the context needs different wording (for example set-default on an
 * inactive template). A 403 without a code means the caller cannot reach the project.
 */
export function mapTemplateError(err: unknown, overrides: Record<string, string> = {}): TemplateErrorMessage {
  const code = errorCode(err);
  const status = (err as HttpErrorResponse | undefined)?.status;
  if (code && overrides[code]) {
    return { key: overrides[code], code };
  }
  if (code === 'TARGET_TREE_IN_USE') {
    const body = (err as HttpErrorResponse).error;
    return { key: PREFIX + 'TARGET_TREE_IN_USE', params: { nodes: body.nodes ?? 0, entries: body.entries ?? 0 }, code };
  }
  if (code && CODE_KEYS[code]) {
    return { key: PREFIX + CODE_KEYS[code], code };
  }
  if (status === 403) {
    return { key: PREFIX + 'FORBIDDEN', code };
  }
  return { key: PREFIX + 'GENERIC', code };
}
